import PropTypes from 'prop-types'
import { Fragment } from 'react'

import theme from 'theme'

export default function ChartValueLine({
  yCoord,
  endX,
  label,
  color,
  startX = 0
}) {
  return (
    <Fragment>
      <line
        stroke={color}
        strokeDasharray="2,2"
        strokeWidth={1.5}
        x1={endX}
        x2={startX}
        y1={yCoord}
        y2={yCoord}
      />
      <text
        css={{
          fill: color,
          textAnchor: 'end',
          fontSize: theme.fontSizes[0],
          textAlign: 'right'
        }}
        dy="0.1em"
        x={endX}
        y={yCoord - 8}
      >
        {label}
      </text>
    </Fragment>
  )
}

ChartValueLine.propTypes = {
  yCoord: PropTypes.number,
  endX: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  endY: PropTypes.number,
  color: PropTypes.string,
  startX: PropTypes.number
}
